var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnauthorised(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_2044)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 74,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.75 57.75H104.375V45.375C104.375 37.319 101.175 29.593 95.4784 23.8966C89.7819 18.2002 82.056 15 74 15C65.944 15 58.218 18.2002 52.5216 23.8966C46.8252 29.593 43.625 37.319 43.625 45.375V57.75H40.25C37.8631 57.75 35.5739 58.6982 33.886 60.386C32.1982 62.0739 31.25 64.3631 31.25 66.75V114C31.25 116.387 32.1982 118.676 33.886 120.364C35.5739 122.052 37.8631 123 40.25 123H107.75C110.137 123 112.426 122.052 114.114 120.364C115.802 118.676 116.75 116.387 116.75 114V66.75C116.75 64.3631 115.802 62.0739 114.114 60.386C112.426 58.6982 110.137 57.75 107.75 57.75ZM65 84.75C65 82.3631 65.9482 80.0739 67.636 78.386C69.3239 76.6982 71.6131 75.75 74 75.75C76.3869 75.75 78.6761 76.6982 80.364 78.386C82.0518 80.0739 83 82.3631 83 84.75C82.9905 86.3206 82.5702 87.8614 81.7807 89.2193C80.9913 90.5771 79.8602 91.7047 78.5 92.49V102.75C78.5 103.943 78.0259 105.088 77.182 105.932C76.3381 106.776 75.1935 107.25 74 107.25C72.8065 107.25 71.6619 106.776 70.818 105.932C69.9741 105.088 69.5 103.943 69.5 102.75V92.49C68.1398 91.7047 67.0087 90.5771 66.2193 89.2193C65.4298 87.8614 65.0095 86.3206 65 84.75ZM54.875 45.375C54.875 40.3027 56.89 35.4382 60.4766 31.8516C64.0632 28.2649 68.9277 26.25 74 26.25C79.0723 26.25 83.9368 28.2649 87.5234 31.8516C91.1101 35.4382 93.125 40.3027 93.125 45.375V55.5C93.125 55.7955 93.0668 56.0881 92.9537 56.361C92.8407 56.634 92.6749 56.8821 92.466 57.091C92.2571 57.2999 92.009 57.4657 91.736 57.5787C91.4631 57.6918 91.1705 57.75 90.875 57.75H57.125C56.5283 57.75 55.956 57.513 55.534 57.091C55.1121 56.669 54.875 56.0967 54.875 55.5V45.375Z",
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_2044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorised);
export default __webpack_public_path__ + "static/media/unauthorised.f49d54a5644c93d944b726db72336415.svg";
export { ForwardRef as ReactComponent };